export const filtersConstants = {
	RESET_FILTERS: "RESET_FILTERS",
	APPLY_FILTERS: "APPLY_FILTERS",
	SET_IS_EXPORTED: "SET_IS_EXPORTED",
	REMOVE_KEY: "REMOVE_KEY",
};
